<script>

import Hoverable from './Hoverable'

export default {

  mixins: [Hoverable],

  props: {
    actions: {
      type: Array
    },

    globalOutput: {
      type: Object
    }
  },

  data() {
    return {
      draggingRowIndex: null
    }
  },

  methods: {
    hoverInput(action, inputName) {
      this.hoverId = action.input_mapping[inputName]
    },

    hoverOutput(action, inputName) {
      this.hoverId = `${action.uuid}_${inputName}`
    },

    shouldHighlightInput(action, inputName) {
      return this.isHovered(action.input_mapping[inputName])
    },

    shouldHighlightOutput(action, inputName) {
      return this.isHovered(`${action.uuid}_${inputName}`)
    },

    edit(action) {
      this.$emit('editAction', action)
    },

    destroy(action) {
      if (!confirm('Really?')) { return }
      this.$emit('destroyAction', action)
    },

    dragstart (payload) {
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'all'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'all'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      this.actions.splice(droppedOnRowIndex, 0, this.actions.splice(this.draggingRowIndex, 1)[0])
      this.$emit('update:actions', this.actions)
    },

    isGlobalOutput(action, outputName) {
      let id = [action.uuid, outputName].join('_')
      return !!this.globalOutput[id]
    },

    toggleGlobalOutput(action, outputName) {
      let id = [action.uuid, outputName].join('_')
      if (this.globalOutput[id]) {
        this.$delete(this.globalOutput, id)
      } else {
        this.$set(this.globalOutput, id, {
          action: {
            name: action.name,
            uuid: action.uuid
          },
          name: outputName
        })
      }
      this.$emit('update:globalOutput', this.globalOutput)
    }
  }
}
</script>

<template>
  <b-table
    :data="actions"
    :hoverable="true"
    draggable
    @dragstart="dragstart"
    @drop="drop"
    @dragover="dragover"
    @dragleave="dragleave"
  >
    <template slot-scope="props">
      <b-table-column field="name" label="Name" class="is-size-7">
        {{ props.row.name }}
        <br>

        <span class="tag" v-if="props.row.runtime_traits">
          Traits at runtime
        </span>
        <span v-else v-for="traitUuid in props.row.traits" class="tag">
          {{ props.row.template().traits[traitUuid].name }}
        </span>

      </b-table-column>
      <b-table-column field="requires" label="Requires">

        <div class="tags" style="max-width: 200px">
          <span v-for="key in props.row.template().inputNames"
              @mouseout="hoverId = null"
              @mouseenter="hoverInput(props.row, key)"
              :class="['tag', {'is-primary': shouldHighlightInput(props.row, key)}]"
          >
            {{ key }}
            <span v-if="props.row.static_params[key]" class="is-italic">&nbsp;= {{ props.row.static_params[key] }}</span>
          </span>

        </div>

      </b-table-column>
      <b-table-column field="requires" label="Provides">

        <div class="tags has-addons has-no-margin-bottom" v-for="key in props.row.template().outputNames">
          <a :class="{tag: true, 'tag-link': true, 'inactive': !isGlobalOutput(props.row, key), 'is-success': isGlobalOutput(props.row, key)}" @click="toggleGlobalOutput(props.row, key)">
            <b-icon icon="earth" size="is-small"></b-icon>
          </a>

          <span
              @mouseout="hoverId = null"
              @mouseenter="hoverOutput(props.row, key)"
              :class="['tag', {'is-primary': shouldHighlightOutput(props.row, key)}]"
          >
            {{ key }}
          </span>
        </div>

      </b-table-column>
      <b-table-column field="requires" label="" width="90">
        <div class="buttons is-right">
          <b-button icon-left="square-edit-outline" size="is-small" @click="edit(props.row)">
          </b-button>

          <b-button icon-left="trash-can-outline" size="is-small" type="is-danger" @click="destroy(props.row)">
          </b-button>
        </div>
      </b-table-column>
    </template>
  </b-table>
</template>

<style lang="scss">
tr[draggable="true"] {
  cursor: move;
}
.tags.has-no-margin-bottom {
  margin-bottom: 0 !important;
}

.tag.tag-link{
  background-color: #ccc;
  &.inactive {
    opacity: 0.6;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>